export default __webpack_public_path__ + "static/media/lc.0d361ba5.svg";